module.exports = __webpack_public_path__ + "img/zdl.973ac8ef.png";